import { render, staticRenderFns } from "./clinicsettingproductpricetype.vue?vue&type=template&id=3d1f6244&scoped=true&"
import script from "./clinicsettingproductpricetype.vue?vue&type=script&lang=js&"
export * from "./clinicsettingproductpricetype.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./clinicsettingproductpricetype.vue?vue&type=style&index=1&id=3d1f6244&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1f6244",
  null
  
)

export default component.exports